/* mc-vip.js — Central de Clientes VIP */
(function(){
'use strict';

var API='https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec';
var TOKEN='mc_cc6f126b6aaf46bfa553068c22727813';

var _all=[];
var _filter='all';
var _sort='score';
var _dir=-1;

/* ── JSONP helper ─────────────────────────────────────────────────────────── */
function call(route,params){
  return new Promise(function(ok,fail){
    var cb='vip_'+Date.now()+'_'+Math.random().toString(36).slice(2);
    var url=API+'?callback='+cb+'&key='+TOKEN+'&resource='+route;
    if(params){Object.keys(params).forEach(function(k){url+='&'+k+'='+encodeURIComponent(params[k]);});}
    var s=document.createElement('script');
    var t=setTimeout(function(){cleanup();fail(new Error('Timeout'));},25000);
    window[cb]=function(d){cleanup();ok(d);};
    function cleanup(){clearTimeout(t);delete window[cb];if(s.parentNode)s.parentNode.removeChild(s);}
    s.onerror=function(){cleanup();fail(new Error('Erro de rede'));};
    s.src=url;
    document.head.appendChild(s);
  });
}

/* ── Score (mesma lógica de cliente.html) ─────────────────────────────────── */
function computeScore(c){
  var ltv=Number(c.valor_gasto)||0;
  var orders=Number(c.total_pedidos)||0;
  var freqMes=Number(c.frequencia_mes)||0;
  var lastDays=Number(c.dias_desde_ultima)||999;
  var margem=Number(c.avg_margem)||0;
  var score=0;
  // Valor LTV (30pts)
  score+=ltv>2000?30:ltv>1000?22:ltv>500?15:ltv>200?8:3;
  // Frequência compras/mês (20pts)
  score+=freqMes>1.5?20:freqMes>1?15:freqMes>0.67?10:freqMes>0.5?5:freqMes>0?2:0;
  // Recência (20pts)
  score+=lastDays<7?20:lastDays<15?16:lastDays<30?12:lastDays<60?7:lastDays<90?3:1;
  // Pedidos (15pts)
  score+=orders>=10?15:orders>=5?10:orders>=3?7:orders>=2?4:1;
  // Rentabilidade média (15pts)
  score+=margem>50?15:margem>35?12:margem>20?8:margem>0?4:0;
  return Math.min(100,score);
}

function segment(score){
  if(score>=90)return{lbl:'Campeão',color:'#fff200'};
  if(score>=80)return{lbl:'VIP',color:'#48f91e'};
  if(score>=70)return{lbl:'Premium',color:'#48f91e'};
  if(score>=60)return{lbl:'Promissor',color:'#f5a623'};
  if(score>=40)return{lbl:'Comum',color:'#8a8a8a'};
  return{lbl:'Baixo',color:'#ff4d4d'};
}

/* ── Helpers ──────────────────────────────────────────────────────────────── */
function BRL(n){return'R$ '+(Number(n)||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});}
function NUM(n){return(Number(n)||0).toLocaleString('pt-BR');}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c];});}
function relDate(days){
  if(!days&&days!==0)return'—';
  var d=Number(days)||0;
  if(d<1)return'hoje';if(d===1)return'ontem';
  if(d<7)return d+'d';if(d<30)return Math.round(d/7)+'sem';
  if(d<365)return Math.round(d/30)+'m';return Math.round(d/365)+'a';
}
function scoreRing(score,size,color){
  size=size||36;color=color||'#fff200';
  var r=size/2-3,circ=2*Math.PI*r;
  var dash=(circ*(score/100)).toFixed(2),gap=(circ-circ*(score/100)).toFixed(2);
  return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 '+size+' '+size+'" style="transform:rotate(-90deg);flex-shrink:0">'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="#1e1e1e" stroke-width="3"/>'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="'+color+'" stroke-width="3" stroke-linecap="round"'
    +' stroke-dasharray="'+dash+' '+gap+'"/></svg>';
}

/* ── Derived sets ─────────────────────────────────────────────────────────── */
function atRisk(){
  return _all.filter(function(c){
    if(c.score<70)return false;
    var avgDays=c.frequencia_mes>0?30/c.frequencia_mes:0;
    return Number(c.dias_desde_ultima)>Math.max(avgDays*1.5,45);
  });
}
function futureVips(){
  return _all.filter(function(c){
    return c.score>=55&&c.score<70&&Number(c.dias_desde_ultima)<60&&Number(c.total_pedidos)>=2;
  });
}
function filtered(){
  if(_filter==='all')return _all;
  if(_filter==='campeon')return _all.filter(function(c){return c.score>=90;});
  if(_filter==='vip')return _all.filter(function(c){return c.score>=80&&c.score<90;});
  if(_filter==='premium')return _all.filter(function(c){return c.score>=70&&c.score<80;});
  if(_filter==='promissor')return _all.filter(function(c){return c.score>=60&&c.score<70;});
  if(_filter==='risco')return atRisk();
  if(_filter==='futuro')return futureVips();
  return _all;
}

/* ── Load ─────────────────────────────────────────────────────────────────── */
function vipLoad(){
  var loading=document.getElementById('mc-loading');
  var errEl=document.getElementById('mc-err');
  var main=document.getElementById('vip-main');
  loading.style.display='block';
  errEl.hidden=true;
  main.style.display='none';
  document.getElementById('vip-sub').textContent='Carregando...';

  call('vip_hub').then(function(r){
    if(!r||r.error)throw new Error(r&&r.error?r.error:'Sem dados');
    var raw=Array.isArray(r.customers)?r.customers:[];
    _all=raw.map(function(c){
      var score=computeScore(c);
      var seg=segment(score);
      return {
        id:String(c.id||''),
        nome:String(c.nome||c.name||'—'),
        email:String(c.email||''),
        phone:String(c.phone||''),
        cidade:String(c.cidade||''),
        estado:String(c.estado||''),
        total_pedidos:Number(c.total_pedidos)||0,
        valor_gasto:Number(c.valor_gasto)||0,
        ticket_medio:Number(c.ticket_medio)||0,
        primeira_compra:c.primeira_compra||'',
        ultima_compra:c.ultima_compra||'',
        dias_desde_ultima:Number(c.dias_desde_ultima)||0,
        frequencia_mes:Number(c.frequencia_mes)||0,
        avg_margem:Number(c.avg_margem)||0,
        lucro_total:Number(c.lucro_total)||0,
        cupons_usados:Number(c.cupons_usados)||0,
        origem_primeira:String(c.origem_primeira||''),
        score:score,
        segment:seg.lbl,
        segColor:seg.color
      };
    }).sort(function(a,b){return b.score-a.score;});

    loading.style.display='none';
    main.style.display='block';
    var vips=_all.filter(function(c){return c.score>=70;});
    document.getElementById('vip-sub').textContent=
      NUM(_all.length)+' clientes analisados · '+NUM(vips.length)+' VIP+ · atualizado agora';
    render();
  }).catch(function(e){
    loading.style.display='none';
    errEl.hidden=false;
    errEl.textContent='Erro: '+String(e.message||e);
  });
}

/* ── Render all ───────────────────────────────────────────────────────────── */
function render(){
  renderKpis();renderTabs();renderRanking();renderRisk();renderFuture();renderRevenue();renderInsights();
}

/* ── KPIs ─────────────────────────────────────────────────────────────────── */
function renderKpis(){
  var vips=_all.filter(function(c){return c.score>=70;});
  var campeons=_all.filter(function(c){return c.score>=90;});
  var totalLtv=_all.reduce(function(s,c){return s+c.valor_gasto;},0);
  var vipLtv=vips.reduce(function(s,c){return s+c.valor_gasto;},0);
  var vipOrders=vips.reduce(function(s,c){return s+c.total_pedidos;},0);
  var avgTicket=vipOrders?vipLtv/vipOrders:0;
  var pct=totalLtv>0?((vipLtv/totalLtv)*100).toFixed(1):'0';
  var risk=atRisk().length,future=futureVips().length;
  var kpis=[
    {lbl:'Clientes VIP+',val:NUM(vips.length),sub:'score ≥ 70'},
    {lbl:'Receita VIP',val:BRL(vipLtv),sub:pct+'% do total',cls:'acc'},
    {lbl:'Ticket Médio VIP',val:BRL(avgTicket),sub:'por pedido'},
    {lbl:'Campeões',val:NUM(campeons.length),sub:'score ≥ 90'},
    {lbl:'Em Risco',val:NUM(risk),sub:'VIP+ inativos',cls:risk>0?'bad':''},
    {lbl:'Futuros VIPs',val:NUM(future),sub:'Promissores ativos',cls:'acc'}
  ];
  document.getElementById('vip-kpis').innerHTML=kpis.map(function(k){
    return '<div class="vip-kpi"><div class="vip-kpi-val'+(k.cls?' '+k.cls:'')+'">'
      +k.val+'</div><div class="vip-kpi-lbl">'+k.lbl+'</div><div class="vip-kpi-sub">'+k.sub+'</div></div>';
  }).join('');
}

/* ── Tabs ─────────────────────────────────────────────────────────────────── */
function renderTabs(){
  var tabs=[
    {id:'all',lbl:'Todos',count:_all.length},
    {id:'campeon',lbl:'Campeão',count:_all.filter(function(c){return c.score>=90;}).length},
    {id:'vip',lbl:'VIP',count:_all.filter(function(c){return c.score>=80&&c.score<90;}).length},
    {id:'premium',lbl:'Premium',count:_all.filter(function(c){return c.score>=70&&c.score<80;}).length},
    {id:'promissor',lbl:'Promissor',count:_all.filter(function(c){return c.score>=60&&c.score<70;}).length},
    {id:'risco',lbl:'⚠ Em Risco',count:atRisk().length},
    {id:'futuro',lbl:'🚀 Futuros',count:futureVips().length}
  ];
  document.getElementById('vip-tabs').innerHTML=tabs.map(function(t){
    return '<button class="vip-tab'+(t.id===_filter?' active':'')+'" onclick="vipFilter(\''+t.id+'\')">'
      +esc(t.lbl)+'<span class="vip-tab-cnt">'+t.count+'</span></button>';
  }).join('');
}

/* ── Ranking ──────────────────────────────────────────────────────────────── */
function renderRanking(){
  var list=filtered().slice().sort(function(a,b){
    var av=Number(a[_sort])||0,bv=Number(b[_sort])||0;
    return _dir*(bv-av);
  });
  var lim=60;
  var rows=list.slice(0,lim).map(function(c,i){
    var seg=segment(c.score);
    var daysCls=c.dias_desde_ultima<30?'good':c.dias_desde_ultima<60?'warn':'bad';
    var id=c.id||c.email||'';
    return '<tr class="vip-row" onclick="window.location=\'/pages/cliente?id='+esc(id)+'\'">'
      +'<td class="vip-rank">'+(i+1)+'</td>'
      +'<td style="display:flex;align-items:center;gap:6px;padding:7px 8px">'
        +scoreRing(c.score,32,seg.color)
        +'<span style="font-size:10px;color:'+seg.color+'">'+c.score+'</span>'
      +'</td>'
      +'<td class="vip-name-cell"><div class="vip-name">'+esc(c.nome.slice(0,28))+'</div>'
        +'<div class="vip-email">'+esc((c.email||c.phone||'').slice(0,30))+'</div></td>'
      +'<td><span class="vip-badge" style="color:'+seg.color+';border-color:'+seg.color+'33">'+seg.lbl+'</span></td>'
      +'<td class="r">'+BRL(c.valor_gasto)+'</td>'
      +'<td class="r">'+NUM(c.total_pedidos)+'</td>'
      +'<td class="r '+daysCls+'">'+relDate(c.dias_desde_ultima)+'</td>'
      +'<td class="r">'+BRL(c.ticket_medio)+'</td>'
      +'<td class="vip-go">›</td>'
      +'</tr>';
  }).join('');

  function th(col,lbl){
    var ico=_sort===col?(_dir>0?'↑':'↓'):'⇅';
    var cls=_sort===col?'acc':'mut';
    return '<th class="r" onclick="vipSort(\''+col+'\')" style="cursor:pointer">'+lbl+'<span class="sort-ico '+cls+'">'+ico+'</span></th>';
  }
  function thS(col,lbl){
    var ico=_sort===col?(_dir>0?'↑':'↓'):'⇅';
    var cls=_sort===col?'acc':'mut';
    return '<th onclick="vipSort(\''+col+'\')" style="cursor:pointer">'+lbl+'<span class="sort-ico '+cls+'">'+ico+'</span></th>';
  }

  document.getElementById('vip-ranking').innerHTML=
    '<div style="overflow-x:auto"><table class="vip-table">'
    +'<thead><tr>'
    +'<th>#</th>'
    +thS('score','Score')
    +'<th>Nome</th><th>Segmento</th>'
    +th('valor_gasto','LTV')
    +th('total_pedidos','Pedidos')
    +'<th class="r">Última</th>'
    +th('ticket_medio','Ticket')
    +'<th></th>'
    +'</tr></thead>'
    +'<tbody>'+rows+'</tbody>'
    +'</table></div>'
    +(list.length>lim?'<div class="vip-more">top '+lim+' de '+NUM(list.length)+' clientes no filtro</div>':'');
}

/* ── Em Risco ─────────────────────────────────────────────────────────────── */
function renderRisk(){
  var list=atRisk().slice(0,12);
  var el=document.getElementById('vip-risk');
  if(!list.length){el.innerHTML='<p class="vip-empty">Nenhum cliente VIP+ em risco 🎉</p>';return;}
  el.innerHTML='<div class="vip-cards-grid">'+list.map(function(c){
    var seg=segment(c.score);
    var avg=c.frequencia_mes>0?Math.round(30/c.frequencia_mes):0;
    var over=c.dias_desde_ultima-(avg||30);
    var id=c.id||c.email||'';
    return '<div class="vip-risk-card" onclick="window.location=\'/pages/cliente?id='+esc(id)+'\'">'
      +'<div class="vip-rc-top"><span class="vip-name">'+esc(c.nome.slice(0,20))+'</span>'
        +'<span class="vip-badge" style="color:'+seg.color+';border-color:'+seg.color+'33">'+seg.lbl+'</span></div>'
      +'<div class="vip-rc-mid bad">Sem comprar há '+c.dias_desde_ultima+'d'+(avg?' (média '+avg+'d)':'')+'</div>'
      +'<div class="vip-rc-bot"><span>'+BRL(c.valor_gasto)+'</span>'
        +(over>0?'<span class="bad">+'+over+'d</span>':'')+'</div></div>';
  }).join('')+'</div>';
}

/* ── Futuros VIPs ─────────────────────────────────────────────────────────── */
function renderFuture(){
  var list=futureVips().slice(0,12);
  var el=document.getElementById('vip-future');
  if(!list.length){el.innerHTML='<p class="vip-empty">Nenhum futuro VIP identificado.</p>';return;}
  el.innerHTML='<div class="vip-cards-grid">'+list.map(function(c){
    var seg=segment(c.score);
    var pct=Math.round((c.score/70)*100);
    var id=c.id||c.email||'';
    return '<div class="vip-future-card" onclick="window.location=\'/pages/cliente?id='+esc(id)+'\'">'
      +'<div class="vip-rc-top"><span class="vip-name">'+esc(c.nome.slice(0,20))+'</span>'
        +'<span class="vip-badge" style="color:'+seg.color+';border-color:'+seg.color+'33">'+seg.lbl+'</span></div>'
      +'<div class="vip-prog-wrap"><div class="vip-prog-fill" style="width:'+pct+'%"></div></div>'
      +'<div class="vip-rc-bot"><span>'+NUM(c.total_pedidos)+' ped · '+BRL(c.valor_gasto)+'</span>'
        +'<span class="acc">'+c.score+'/100</span></div></div>';
  }).join('')+'</div>';
}

/* ── Revenue por segmento ─────────────────────────────────────────────────── */
function renderRevenue(){
  var segs=[
    {lbl:'Campeão',min:90,max:101,color:'#fff200'},
    {lbl:'VIP',min:80,max:90,color:'#48f91e'},
    {lbl:'Premium',min:70,max:80,color:'#48f91e'},
    {lbl:'Promissor',min:60,max:70,color:'#f5a623'},
    {lbl:'Comum',min:40,max:60,color:'#8a8a8a'},
    {lbl:'Baixo',min:0,max:40,color:'#ff4d4d'}
  ];
  var total=_all.reduce(function(s,c){return s+c.valor_gasto;},0);
  var data=segs.map(function(seg){
    var grp=_all.filter(function(c){return c.score>=seg.min&&c.score<seg.max;});
    var ltv=grp.reduce(function(s,c){return s+c.valor_gasto;},0);
    return{lbl:seg.lbl,ltv:ltv,count:grp.length,color:seg.color,pct:total>0?(ltv/total):0};
  });
  var maxLtv=Math.max.apply(null,data.map(function(d){return d.ltv;}));
  document.getElementById('vip-revenue').innerHTML=data.map(function(d){
    var w=maxLtv>0?Math.round((d.ltv/maxLtv)*100):0;
    return '<div class="vip-rev-row">'
      +'<div class="vip-rev-lbl"><span style="color:'+d.color+'">'+d.lbl+'</span>'
        +' <span class="mut">('+d.count+')</span></div>'
      +'<div class="vip-rev-bar-wrap"><div class="vip-rev-bar" style="width:'+w+'%;background:'+d.color+'22;border-left:3px solid '+d.color+'"></div></div>'
      +'<div class="vip-rev-val">'+BRL(d.ltv)+' <span class="mut">'+( (d.pct*100).toFixed(1) )+'%</span></div>'
      +'</div>';
  }).join('');
}

/* ── Insights ─────────────────────────────────────────────────────────────── */
function renderInsights(){
  var ins=[];
  var vips=_all.filter(function(c){return c.score>=70;});
  var campeons=_all.filter(function(c){return c.score>=90;});
  var risk=atRisk();var future=futureVips();
  var total=_all.reduce(function(s,c){return s+c.valor_gasto;},0);
  var vipLtv=vips.reduce(function(s,c){return s+c.valor_gasto;},0);
  var riskLtv=risk.reduce(function(s,c){return s+c.valor_gasto;},0);
  var vipPct=total>0?((vipLtv/total)*100).toFixed(1):'0';
  var basePct=_all.length?((vips.length/_all.length)*100).toFixed(1):'0';
  var avgScore=_all.length?(_all.reduce(function(s,c){return s+c.score;},0)/_all.length).toFixed(1):'0';

  if(campeons.length){
    var cLtv=campeons.reduce(function(s,c){return s+c.valor_gasto;},0);
    ins.push({t:'pos',ico:'🏆',txt:campeons.length+' Campeão'+(campeons.length>1?'ões':'')+' — '+BRL(cLtv)+' em LTV total ('+( (cLtv/Math.max(total,1)*100).toFixed(1) )+'% da receita)'});
  }
  if(vips.length)ins.push({t:'acc',ico:'💰',txt:'Pareto VIP: '+basePct+'% dos clientes ('+NUM(vips.length)+') geram '+vipPct+'% da receita total'});
  if(risk.length)ins.push({t:'neg',ico:'🚨',txt:risk.length+' cliente'+(risk.length>1?'s':'')+' VIP+ em risco de churn — '+BRL(riskLtv)+' em LTV ameaçado'});
  if(future.length)ins.push({t:'pos',ico:'🚀',txt:future.length+' Promissor'+(future.length>1?'es':'')+' com perfil de crescimento — potencial VIP com 1-2 compras'});
  ins.push({t:'neu',ico:'📊',txt:'Score médio da base: '+avgScore+'/100 — '+(Number(avgScore)>=55?'qualidade saudável':'oportunidade de elevar engajamento')});
  var top=_all[0];
  if(top)ins.push({t:'acc',ico:'👑',txt:'Maior LTV: '+esc(top.nome)+'  · '+BRL(top.valor_gasto)+' · Score '+top.score+'/100 · '+top.total_pedidos+' pedidos'});
  var noFreq=_all.filter(function(c){return c.score>=70&&c.frequencia_mes<0.3;});
  if(noFreq.length)ins.push({t:'neg',ico:'⏰',txt:noFreq.length+' VIP'+(noFreq.length>1?'s':'')+' com frequência baixa (<1 compra/3m) — campanha de reativação indicada'});
  var withCoupon=vips.filter(function(c){return c.cupons_usados>0;});
  if(withCoupon.length>vips.length*0.6)ins.push({t:'neg',ico:'🏷️',txt:Math.round(withCoupon.length/Math.max(vips.length,1)*100)+'% dos VIP+ usam cupom — testar oferta sem desconto para melhorar margem'});

  document.getElementById('vip-insights').innerHTML=ins.map(function(i){
    return '<div class="vip-insight '+i.t+'"><span class="vip-ins-ico">'+i.ico+'</span><span>'+i.txt+'</span></div>';
  }).join('');
}

/* ── Globals ──────────────────────────────────────────────────────────────── */
window.vipLoad=vipLoad;
window.vipFilter=function(f){_filter=f;renderTabs();renderRanking();};
window.vipSort=function(s){if(_sort===s)_dir*=-1;else{_sort=s;_dir=-1;}renderRanking();};

vipLoad();
})();
